import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { messages } from './messages'
import { publicMessages } from './public'
import { adminMessages } from './admin'
import { adminCatalogMessages } from './adminCatalog'
import { adminOperationsMessages } from './adminOperations'
import { cashMessages } from './cash'

const LOCALE_KEY = 'sauda_locale'
const supportedLocales = ['kk', 'ru']
const savedLocale = localStorage.getItem(LOCALE_KEY)
const locale = supportedLocales.includes(savedLocale) ? savedLocale : 'kk'

Vue.use(VueI18n)

const localizedMessages = {
  kk: {
    ...messages.kk,
    ...publicMessages.kk,
    ...adminMessages.kk,
    ...adminCatalogMessages.kk,
    ...adminOperationsMessages.kk,
    ...cashMessages.kk,
  },
  ru: {
    ...messages.ru,
    ...publicMessages.ru,
    ...adminMessages.ru,
    ...adminCatalogMessages.ru,
    ...adminOperationsMessages.ru,
    ...cashMessages.ru,
  },
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'kk',
  messages: localizedMessages,
  silentFallbackWarn: true,
  silentTranslationWarn: true,
})

export function setLocale(nextLocale) {
  if (!supportedLocales.includes(nextLocale)) return

  i18n.locale = nextLocale
  localStorage.setItem(LOCALE_KEY, nextLocale)
  document.documentElement.lang = nextLocale
}

document.documentElement.lang = locale

export default i18n
